import { handleError, handleResponse } from '@/services/api/utils/response.js'
import { getEnvAndDex } from '@/utils/get-env-and-dex.js'
import axios from 'axios'

const BASE_URL = `/api`

const { dex } = getEnvAndDex()

axios.defaults.timeout = 30000;
axios.defaults.headers.post['dex'] = dex;

const index = (resource, option) => {
	return axios
		.get(`${BASE_URL}/${resource}`, option)
		.then(handleResponse)
		.catch(handleError);
}

const findOne = (resource, id, option) => {
	return axios
		.get(`${BASE_URL}/${resource}/${id}`, option)
		.then(handleResponse)
		.catch(handleError);
}

const findAll = (resource, params, option) => {
	return axios
		.post(`${BASE_URL}/${resource}`, params, option)
		.then(handleResponse)
		.catch(handleError);
}

const create = (resource, model, option) => {
	return axios
		.post(`${BASE_URL}/${resource}`, model, option)
		.then(handleResponse)
		.catch(handleError);
}

const update = (resource, model, option) => {
	return axios
		.put(`${BASE_URL}/${resource}`, model, option)
		.then(handleResponse)
		.catch(handleError);
}

const updateById = (resource, id, model, option) => {
	return axios
		.put(`${BASE_URL}/${resource}/${id}`, model, option)
		.then(handleResponse)
		.catch(handleError);
}

const remove = (resource, id, option) => {
	return axios
		.delete(`${BASE_URL}/${resource}/${id}`, option)
		.then(handleResponse)
		.catch(handleError);
}

const upload = (resource, files) => {
	return Promise.all(files.map(file => {
		let formData = new FormData()
		formData.append('files', file)
		return axios
			.post(`${BASE_URL}/${resource}`, formData)
	}))
	.then(handleResponse)
	.catch(handleError)
}

export const apiProvider = {
	index,
	findOne,
	findAll,
	create,
	update,
	updateById,
	remove,
	upload,
	BASE_URL,
}
